<!-- 产品资料 -->
<template>
    <div class="product-material-container">
      <div class="product-pdf" v-show="productMaterial.length != 0">
        
<!--        <div class="no-data" v-if="productMaterial.length == 0">暂且没有pdf文件</div>-->
        <div class="pdf-list" v-for="(item, index) in productMaterial" :key="index">
          <div >
            <!-- <h3 class="h3-title"><span>{{ item.title }}</span></h3> -->
            <div class="pdf-item" @click="previewPdf(item)">
              <div class="pdf-cover">
                <van-image class="cover" :src="cdnUrl.cdnUrl+item.img_url" fit="cover" alt=""/>
                <img class="pdf-icon" src="@/assets/img/pdf.png" alt="">
              </div>
              <div class="pdf-title van-multi-ellipsis--l2">{{item.title}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="no-data" v-if="productMaterial.length == 0">暂且没有资料</div>
    </div>
</template>

<script>
  import { recordVideo, recordPdf } from '@/api/product'

  export default {
    data () {
      return {
        cdnUrl: this.$config.baseUrl
      }
    },
    props: {
      id: {
        type: String,
        defalut: ''
      },
      productMaterial: {
        type: Array,
        defalut: []
      }
    },
    created () {

    },
    mounted () {
      if (this.$refs.aboutType1_video) {
        this.$nextTick(() => {
        var Media = this.$refs.aboutType1_video
          // Media.eventTester('loadstart')
          Media.addEventListener('play', () => {
            this.record()
          })
        })
      }
      
    },
    methods: {
      
      record () {
        var videoId = this.productMaterial.video[0].id
        // console.log(videoId, 666)
        this.recordVideoPort(videoId)
      },
      clickVideo (item) {
        var videoId = item.id
        this.$emit('videoChange', item)
        this.recordVideoPort(videoId)
      },
      previewPdf (item) {
        console.log(item)
        var id = item.type_id
        window.location.href = `${this.cdnUrl.pro}/pageTurnings/index.html?id=${item.type_id}&d=${this.id}`
        this.recordPDFPort(id)
      },
      // 记录PDF浏览记录
      recordPDFPort (pdfId) {
        recordPdf({ id: pdfId }).then(res => {
          console.log(res)
        }).catch(err => {
          console.log('记录pdf浏览记录失败', err)
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
.product-material-container{
  padding: 0 rem(20);
  .no-data{
    font-size: rem(11);
    height: rem(45);
    line-height: rem(45);
    text-align: center;
  }
  .h3-title{
    height: rem(45);
    line-height: rem(45);
    color: #333333;
    font-size: 15px;
    position: relative;
    display: flex;
    align-items: center;
    padding-left: rem(15);
    &:after{
      content: '';
      display: block;
      width: rem(8);
      height: rem(17);
      background: $base-color;
      position: absolute;
      top: 50%;
      left: 0;
      margin-top: rem(-8);
    }
  }
  .product-pdf {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    
  }
  .pdf-list{
    padding: 0 rem(15);
    &:after{
      content: '';
      display: block;
      clear: both;
    }
    .pdf-item{
      margin-bottom: rem(25);
      height: rem(190);
      &:nth-child(odd){
        float: right;
      }
      &:nth-child(even){
        float: left;
      }
      .pdf-cover{
        width: rem(120);
        height: rem(160);
        background: #cfcfcf;
        border-radius: 4px;
        position: relative;
        overflow: hidden;
        .cover{
          /*width: 100%;*/
          height: 100%;
          border-radius: 4px;
        }
        .pdf-icon{
          position: absolute;
          bottom: rem(9);
          right: rem(11);
          width: rem(20);
          height: rem(27);
          z-index: 1;
        }
        .video-icon{
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%,-50%);
          font-size: rem(30);
          color: black;
        }
      }
      .pdf-title{
        width: rem(120);
        margin-top: rem(5);
        font-size: 13px;
        color: #333;
        text-align: center;
      }
    }
  }
}
</style>
